export default __webpack_public_path__ + "static/media/close-window-32.2bd62c82.ico";